import { SyncOutlined } from '@ant-design/icons'
import type { ModalFuncProps } from 'antd'
import { z } from 'zod'

import { ROLES_IN_RUSSIAN } from '@/constants'
import { UserEditSchema } from '@/schemas'
import type { OptionType } from '@/types'

import cn from './Users.module.scss'

const LOGIN_PREFIX = '375'
export const LOGIN_PREFIX_LENGTH = LOGIN_PREFIX.length
const LOGIN_LENGTH = 12

export const userEditFormSchema = UserEditSchema.extend({
  roles: z
    .array(z.object({ value: z.string(), label: z.string() }))
    .min(1, 'Выберите хотя бы одну роль'),
})

export type UserEditFormType = z.infer<typeof userEditFormSchema>

export const getRoleLabel = (role: string, roleOptions: OptionType[]) =>
  roleOptions.find((option) => option.value === role)?.label ||
  ROLES_IN_RUSSIAN[role] ||
  role

export const getRolesChangedModalConfig = (): ModalFuncProps => ({
  icon: null,
  title: (
    <div className={cn.rolesChangedModal}>
      <SyncOutlined className={cn.rolesChangedIcon} />
      <div className={cn.rolesChangedTitle}>Роли пользователя изменены</div>
      <div className={cn.rolesChangedHint}>
        Чтобы изменения ролей вступили в силу, пользователю нужно выйти из
        системы и войти заново.
      </div>
    </div>
  ),
  okText: 'Понятно',
  centered: true,
  closable: false,
  width: 440,
})

export const sanitizeLogin = (raw: string) => {
  const digits = raw.replace(/\D/g, '')
  const rest = (
    digits.startsWith(LOGIN_PREFIX) ? digits.slice(LOGIN_PREFIX_LENGTH) : digits
  ).replace(/^0+/, '')
  return (LOGIN_PREFIX + rest).slice(0, LOGIN_LENGTH)
}
